var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgS4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80.154,
    height: 128.441,
    viewBox: "0 0 80.154 128.441",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M0,55.851H80.154V-72.59H0Z",
    transform: "translate(0 72.59)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_219",
    "data-name": "Group 219",
    transform: "translate(0 72.59)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    "data-name": "Group 218",
    transform: "translate(0 -72.59)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M34.85,4.195c-.005-6.487-3.121-9.627-9.571-9.633q-30.5-.027-60.993,0c-6.462.005-9.572,3.134-9.574,9.626q-.016,54.571,0,109.146c0,6.481,3.123,9.638,9.565,9.643q30.5.029,60.993,0c6.441-.005,9.574-3.167,9.58-9.634q.024-27.287.005-54.574,0-27.284-.005-54.572M29.2,112.769c.009,3.434-1.17,4.574-4.554,4.556q-29.949-.157-59.9-.007c-3.2.014-4.408-1.053-4.386-4.351.115-18.064.055-36.128.055-54.192q0-26.918,0-53.836c0-4.342.326-4.671,4.666-4.673C-15.066.259,4.781.316,24.627.212,27.989.2,29.213,1.279,29.2,4.739q-.143,54.014,0,108.029",
    transform: "translate(45.295 5.452)",
    fill: "#19007c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    "data-name": "Group 215",
    transform: "translate(32.285 11.42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M3.415,1.863q-2.657,0-5.314,0c-1.522,0-2.592-.653-2.539-2.254.048-1.382,1.024-2.028,2.4-2.028q5.314,0,10.627,0c1.525,0,2.615.646,2.537,2.244S9.847,1.9,8.375,1.872c-1.653-.03-3.307-.007-4.96-.009",
    transform: "translate(4.439 2.421)",
    fill: "#19007c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    "data-name": "Group 216",
    transform: "translate(32.229 102.366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M3.485,0A7.865,7.865,0,0,0-4.529,7.758a7.814,7.814,0,0,0,7.847,7.9,7.839,7.839,0,0,0,7.847-7.907A7.893,7.893,0,0,0,3.485,0M3.343,11.415C.173,11.438-1.836,6.569,1.606,4.7A3.7,3.7,0,0,1,6.433,6.134,3.7,3.7,0,0,1,5,10.962a3.515,3.515,0,0,1-1.658.453",
    transform: "translate(4.529 0.001)",
    fill: "#19007c"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS4);
export default __webpack_public_path__ + "static/media/s4.06ea183dddf819561ce4884d2ce1a8e5.svg";
export { ForwardRef as ReactComponent };